
import TextInput from '../../UIComponent/TextInput';
import ButtonLoader from '../../common/buttonLoader/ButtonLoader';
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown';


function EducationalInformation(props) {


    return (
        <>
            <div className='container mx-auto'>
                <div className='grid grid-cols-12 gap-4'>
                    <div className='col-span-12'>
                        <div className='bg-gray-box  '>
                            <div className='form-info-title'>
                                <h4 className='text-[#2d2d2d] form-info-title-txt'>
                                    Educational Qualifications (Tertiary Only)
                                </h4>
                            </div>
                            <div className='col-span-12 '>
                                <div className="mb-2" >
                                </div>
                                <div className='table-section'>
                                    <div className='overflow-x-auto'>
                                        <table className='w-full'>
                                            <thead className='bg-[#005b9c] text-white'>
                                                <tr>
                                                    <th className='text-left py-3 px-5'>
                                                        Name of Institution
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Title of Course
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Type of Qualification
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Year of Award
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Duration of Programme
                                                    </th>

                                                    <th className='text-left py-3 px-5'>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-sm custom-tbody">
                                                {
                                                    props && props.educationalInformation.educationalInformation1?.map((eduInfo1, key) => {
                                                        return (
                                                            <tr className='bg-[#eeeeee] text-black border-t-4 border-[#ffffff]' key={key}>
                                                                <td className='text-left py-2 px-5'>
                                                                    {eduInfo1.nameOfInstitution}
                                                                </td>
                                                                <td className='text-left py-2 px-5'>
                                                                    {eduInfo1.titleOfCourse}
                                                                </td>
                                                                <td className='text-left py-2 px-5'>
                                                                    {eduInfo1.qualificationTypeName}
                                                                </td>
                                                                <td className='text-left py-2 px-5'>
                                                                    {eduInfo1.yearOfAward}
                                                                </td>
                                                                <td className='text-left py-2 px-5'>
                                                                    {eduInfo1.durationOfProgramme}
                                                                </td>

                                                                <td className='py-2 px-5 text-center'>
                                                                    <div className='flex gap-2'>
                                                                        <button
                                                                            className='action-btn flex gap-2'

                                                                            onClick={() => {
                                                                                props.getEducationalInformation(key);
                                                                                props.setOpenEduModal(true);
                                                                            }}

                                                                        >
                                                                            {<img className='min-h-[30px] min-w-[30px] mx-auto' src='../edit.png' alt='' />}

                                                                        </button>
                                                                        <button
                                                                            className='action-btn flex gap-2'
                                                                            onClick={() => props.deleteCpasEducationalInformation(eduInfo1.educationalQualificationId)}
                                                                        >
                                                                            <img className='min-h-[30px] min-w-[30px] mx-auto' src='../delete-icon.svg' alt='' />
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-12 md:gap-10 md:gap-4 gap-3 w-full justify-between mt-5 mb-8">


                                <div className="col-span-12">
                                    <div className='flex justify-end'>
                                        <button
                                            type="button"
                                            className="btn btn-border-caps"
                                            onClick={() => props.setOpenEduModal(true)}
                                        >

                                            <span className='fa fa-plus'></span>
                                            <span className='ml-2'>
                                                Add
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='form-info-title'>
                                <h4 className='text-[#2d2d2d] form-info-title-txt'>
                                    Professional Qualification (WSQ Course: Manage workplace Safety and Healthy in Constructions)
                                </h4>
                                <p className='mt-2 mb-2'>
                                    <b>*Note:</b>All PMs who oversees all construction activities of a contract sum of $10 million or more, is
                                    required to attend WSQ Course: Manage Workplace Safety and Health in Construction Sites [TSC Code:
                                    WPH-GMS-4405-1.1].
                                </p>
                                <p className='mt-2 mb-2'>
                                    <b>Mandatory:</b> Please attach the above mentioned course certificate during submission and complete
                                    course details in the table above.
                                </p>
                            </div>
                            <div className='col-span-12 '>
                                <div className="mb-2" >
                                </div>
                                <div className='table-section'>
                                    <div className='overflow-x-auto'>
                                        <table className='w-full'>
                                            <thead className='bg-[#005b9c] text-white'>
                                                <tr>
                                                    <th className='text-left py-3 px-5'>
                                                        Professional Qualifications
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Organisation
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Validity Duration
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Grade of Membership
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-sm custom-tbody">
                                                {props && props.educationalInformation.educationalInformation2?.map((eduInfo2, key) => {
                                                    return (
                                                        <tr className='bg-[#eeeeee] text-black border-t-4 border-[#ffffff]' key={key}>
                                                            <td className='text-left py-2 px-5'>
                                                                {eduInfo2.professionalQualification}
                                                            </td>
                                                            <td className='text-left py-2 px-5'>
                                                                {eduInfo2.organisation}
                                                            </td>
                                                            <td className='text-left py-2 px-5'>
                                                                {eduInfo2.validityDuration}
                                                            </td>
                                                            <td className='text-left py-2 px-5'>
                                                                {eduInfo2.gradeOfMembership}
                                                            </td>
                                                            <td className='py-2 px-5 text-center'>
                                                                <div className='flex gap-2'>
                                                                    <button
                                                                        className='action-btn flex gap-2'

                                                                        onClick={() => {
                                                                            props.getProfessionalQualifications(key);
                                                                            props.setOpenProModal(true);
                                                                        }}

                                                                    >
                                                                        {<img className='min-h-[30px] min-w-[30px] mx-auto' src='../edit.png' alt='' />}

                                                                    </button>
                                                                    <button
                                                                        className='action-btn flex gap-2'
                                                                        onClick={() => props.deleteCpasProfessionalQualifications(eduInfo2.professionalQualificationId)}
                                                                    >
                                                                        <img className='min-h-[30px] min-w-[30px] mx-auto' src='../delete-icon.svg' alt='' />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-12 md:gap-10 md:gap-4 gap-3 w-full justify-between mt-5">

                                <div className="col-span-12 my-8">
                                    <div className='flex justify-end'>
                                        <button
                                            type="button"
                                            className="btn btn-border-caps"
                                            onClick={() => props.setOpenProModal(true)}
                                        >
                                            <span className='fa fa-plus'></span>
                                            <span className='ml-2'>
                                                Add
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className='form-info-title'>
                                <h4 className='text-[#2d2d2d] form-info-title-txt'>
                                    Professional Qualifications (If Applicable)
                                </h4>
                                <p className='mt-2 mb-2'>
                                    <b>*Note:</b>&nbsp;All PMs who oversees all construction activities of a contract sum of $10 million or more, is
                                    required to attend WSQ Course: Manage Workplace Safety and Health in Construction Sites [TSC Code:
                                    WPH-GMS-4405-1.1].
                                </p>
                                <p className='mt-2 mb-2'>
                                    <b>Mandatory:</b> Please attach the above mentioned course certificate during submission and complete
                                    course details in the table above.
                                </p>
                            </div>
                            <div className='col-span-12 '>
                                <div className="mb-2" >
                                </div>
                                <div className='table-section'>
                                    <div className='overflow-x-auto'>
                                        <table className='w-full'>
                                            <thead className='bg-[#005b9c] text-white'>
                                                <tr>
                                                    <th className='text-left py-3 px-5'>
                                                        Professional Qualifications
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Organisation
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Validity Duration
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                        Grade of Membership
                                                    </th>
                                                    <th className='text-left py-3 px-5'>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="text-sm custom-tbody">
                                                {props && props.educationalInformation.educationalInformation3?.map((eduInfo3, key) => {
                                                    return (
                                                        <tr className='bg-[#eeeeee] text-black border-t-4 border-[#ffffff]' key={key}>
                                                            <td className='text-left py-2 px-5'>
                                                                {eduInfo3.professionalQualificationName}
                                                            </td>
                                                            <td className='text-left py-2 px-5'>
                                                                {eduInfo3.organisation}
                                                            </td>
                                                            <td className='text-left py-2 px-5'>
                                                                {eduInfo3.validityDuration}
                                                            </td>
                                                            <td className='text-left py-2 px-5'>
                                                                {eduInfo3.gradeOfMembership}
                                                            </td>
                                                            <td className='py-2 px-5 text-center'>
                                                                <div className='flex gap-2'>
                                                                    <button
                                                                        className='action-btn flex gap-2'

                                                                        onClick={() => {
                                                                            props.getProfessionalIfApplicableQualifications(key);
                                                                            props.setOpenProfappModal(true);
                                                                        }}

                                                                    >
                                                                        {<img className='min-h-[30px] min-w-[30px] mx-auto' src='../edit.png' alt='' />}

                                                                    </button>
                                                                    <button
                                                                        className='action-btn flex gap-2'
                                                                        onClick={() => props.deleteCpasProfessionalIfApplicableQualifications(eduInfo3.professionalQualificationApplicableId)}
                                                                    >
                                                                        <img className='min-h-[30px] min-w-[30px] mx-auto' src='../delete-icon.svg' alt='' />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="grid grid-cols-12 md:gap-10 md:gap-4 gap-3 w-full justify-between mt-5">

                                <div className="col-span-12 my-8">
                                    <div className='flex justify-end'>
                                        <button
                                            type="button"
                                            className="btn btn-border-caps"
                                            onClick={() => props.setOpenProfappModal(true)}
                                        >
                                            <span className='fa fa-plus'></span>
                                            <span className='ml-2'>
                                                Add
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
            {props.openEduModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                    <div className="bg-white w-[90%] max-w-4xl rounded-lg shadow-lg p-6 relative">

                        {/* Header */}
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-semibold">Add Educational Qualification</h3>
                            <button className="text-xl font-bold" onClick={() => props.setOpenEduModal(false)}>×</button>
                        </div>

                        {/* FORM CONTENT */}
                        <div className="grid grid-cols-12 gap-4">

                            {/* Name of Institution */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">
                                    Name of Institution <span className="text-[#C00000]">*</span>
                                </h2>
                                <TextInput
                                    name="nameOfInstitution"
                                    value={props.detail1.nameOfInstitution}
                                    identity="CAPS_Application"
                                    handleChange={(e) => props.handleChange(e, "Educational_Qualification")}
                                //onBlur={() => props.validateField("nameOfInstitution", "Educational_Qualification")}
                                />
                            </div>

                            {/* Title of Course */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">
                                    Title of Course <span className="text-[#C00000]">*</span>
                                </h2>
                                <TextInput
                                    name="titleOfCourse"
                                    value={props.detail1.titleOfCourse}
                                    identity="CAPS_Application"
                                    handleChange={(e) => props.handleChange(e, "Educational_Qualification")}
                                //onBlur={() => props.validateField("titleOfCourse", "Educational_Qualification")}
                                />
                            </div>

                            {/* Qualification Type */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts multi-select-dropdown">
                                <h2 className="input-title mb-3">
                                    Type of Qualification<span className="text-[#C00000]">*</span>
                                </h2>

                                <MultiSelectDropdown
                                    drpIdentity="Qualification_Type"
                                    options={props.qualificationTypeList}
                                    // isMulti
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={props.handleChangeSelectorDropdown}
                                    allowSelectAll={false}
                                    value={props.qualificationTypeList.filter(duration => duration.value === props.detail1.qualificationTypeId)}
                                />
                            </div>

                            {/* Year of Award */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">
                                    Year of Award <span className="text-[#C00000]">*</span>
                                </h2>
                                <TextInput
                                    name="yearOfAward"
                                    value={props.detail1.yearOfAward}
                                    identity="CAPS_Application"
                                    handleChange={(e) => props.handleChange(e, "Educational_Qualification")}
                                />
                            </div>

                            {/* Duration of Programme */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">
                                    Duration of Programme <span className="text-[#C00000]">*</span>
                                </h2>
                                <TextInput
                                    name="durationOfProgramme"
                                    value={props.detail1.durationOfProgramme}
                                    identity="CAPS_Application"
                                    handleChange={(e) => props.handleChange(e, "Educational_Qualification")}
                                />
                            </div>

                            {/* File Upload */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">
                                    Upload Certificate <span className="text-[#C00000]">*</span>
                                    <span className='input mr-5 text-[#808080]'>(PDF, DOC, DOCX, JPG, JPEG, and PNG files only)</span>
                                </h2>

                                <div className="flex item-center flex-col">
                                    {
                                        props && props.isUploadEducationalQualifications ?
                                            <ButtonLoader type='btn btn-conquas' />
                                            :
                                            (
                                                <>
                                                    <div className='eduinfo-uplaod-button flex'>
                                                        <form className="custom-uploader custom-file-upload-btn flex">
                                                            <div className='border border-[#f3f3f3] btn  btn-caps cursor-pointer'>
                                                                <label
                                                                    htmlFor={`Education_Qualification_Training`}
                                                                    className="text-uplod text-white cursor-pointer"
                                                                >
                                                                    Upload File
                                                                </label>
                                                                <input
                                                                    className="sr-only"
                                                                    id={`Education_Qualification_Training`}
                                                                    type="file"
                                                                    onChange={(event) => props.onFileChange(event, "Education_Qualification_Training")}
                                                                />
                                                            </div>
                                                        </form>
                                                        {
                                                            props.detail1.certificateOfEducation ? (
                                                                <button className="ml-5 2xl:px-7 lg:px-5 py-2 btn border text-[#005b9c] font-semibold tracking-normal underline"
                                                                    style={{ borderColor: '#005b9c' }}
                                                                    onClick={(event) => props.GetCPASMemberFiles('Education_Qualification_Training', props.detail1.certificateOfEducation)}
                                                                >
                                                                    View File
                                                                </button>
                                                            ) : null
                                                        }
                                                    </div>

                                                </>
                                            )
                                    }
                                    {
                                        props && props.detail1.certificateOfEducation ?
                                            (
                                                <div className='mt-5 file-uploaded-txt flex items-center'>
                                                    <span className='text-[#000]'>
                                                        {props.detail1.certificateOfEducation}
                                                    </span>
                                                </div>
                                            )
                                            :
                                            null
                                    }

                                </div>

                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex justify-end gap-3 mt-6">
                            <button className="btn btn-border-caps" onClick={() => props.setOpenEduModal(false)}>Cancel</button>
                            <button className="btn btn-caps" onClick={() => {
                                props.handleAddRemoveDataList("HandleAdd", "EducationalQualification");
                                // props.setOpenEduModal(false);
                            }}>Save</button>
                        </div>

                    </div>
                </div>
            )}

            {props.openProModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                    <div className="bg-white w-[90%] max-w-4xl rounded-lg shadow-lg p-6 relative">

                        {/* Header */}
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-semibold">
                                Add Professional Qualification
                            </h3>
                            <button
                                className="text-xl font-bold"
                                onClick={() => props.setOpenProModal(false)}
                            >
                                ×
                            </button>
                        </div>

                        {/* FORM CONTENT */}
                        <div className="grid grid-cols-12 gap-4">

                            {/* Professional Qualification */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">Professional Qualifications <span className="text-[#C00000]"> *</span></h2>
                                <TextInput
                                    name="professionalQualification"
                                    value={props.detail2.professionalQualification}
                                    identity="CAPS_Application"
                                    handleChange={(e) =>
                                        props.handleChange(e, "Professional_Qualification")
                                    }
                                //onBlur={() =>props.validateField("professionalQualification","Professional_Qualification")}
                                />
                                {/* <ValidationText
                                    error={
                                        props.validStateProfessionalQualification.error.professionalQualification
                                    }
                                /> */}
                            </div>

                            {/* Organisation */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">Organisation <span className="text-[#C00000]"> *</span></h2>
                                <TextInput
                                    name="organisation"
                                    value={props.detail2.organisation}
                                    identity="CAPS_Application"
                                    handleChange={(e) =>
                                        props.handleChange(e, "Professional_Qualification")
                                    }
                                //onBlur={() =>
                                // props.validateField("organisation", "Professional_Qualification")
                                //}
                                />
                                {/* <ValidationText
                                    error={
                                        props.validStateProfessionalQualification.error.organisation
                                    }
                                /> */}
                            </div>

                            {/* Validity Duration */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">Validity Duration <span className="text-[#C00000]"> *</span></h2>

                                <TextInput
                                    name="validityDuration"
                                    value={props.detail2.validityDuration}
                                    identity="CAPS_Application"
                                    handleChange={(e) =>
                                        props.handleChange(e, "Professional_Qualification")
                                    }
                                //onBlur={() =>
                                //  props.validateField("organisation", "Professional_Qualification")
                                //}
                                />
                                {/* <ValidationText
                                    error={
                                        props.validStateProfessionalQualification.error.validityDuration
                                    }
                                /> */}
                            </div>

                            {/* Membership Grade */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">
                                    Grade of Membership (If Applicable) <span className="text-[#C00000]"> *</span>
                                </h2>

                                <TextInput
                                    name="gradeOfMembership"
                                    value={props.detail2.gradeOfMembership}
                                    identity="CAPS_Application"
                                    handleChange={(e) =>
                                        props.handleChange(e, "Professional_Qualification")
                                    }
                                //onBlur={() =>
                                //  props.validateField("organisation", "Professional_Qualification")
                                // }
                                />
                                {/* <ValidationText
                                    error={
                                        props.validStateProfessionalQualification.error.gradeOfMembership
                                    }
                                /> */}
                            </div>

                            {/* File Upload */}
                            {/* File Upload */}
                            <div className="lg:col-span-12 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">
                                    Upload Certificate <span className="text-[#C00000]">*</span>
                                    <span className='input mr-5 text-[#808080]'> (PDF, DOC, DOCX, JPG, JPEG, and PNG files only)</span>
                                </h2>
                                <div className="flex item-center flex-col">
                                    {
                                        props && props.isUploadProfessionalQualifications ?
                                            <ButtonLoader type='btn btn-conquas' />
                                            :
                                            (
                                                <>
                                                    <div className='eduinfo-uplaod-button flex'>
                                                        <form className="custom-uploader custom-file-upload-btn flex">
                                                            <div className='border border-[#f3f3f3] btn  btn-caps cursor-pointer'>
                                                                <label
                                                                    htmlFor={`Professional_Qualification_Training`}
                                                                    className="text-uplod text-white cursor-pointer"
                                                                >
                                                                    Upload File
                                                                </label>
                                                                <input
                                                                    className="sr-only"
                                                                    id={`Professional_Qualification_Training`}
                                                                    type="file"
                                                                    onChange={(event) => props.onFileChange(event, "Professional_Qualification_Training")}
                                                                />
                                                            </div>
                                                        </form>
                                                        {
                                                            props.detail2.certificateFilePath ? (
                                                                <button className="ml-5 2xl:px-7 lg:px-5 py-2 btn border text-[#005b9c] font-semibold tracking-normal underline"
                                                                    style={{ borderColor: '#005b9c' }}
                                                                    onClick={(event) => props.GetCPASMemberFiles('Professional_Qualification_Training', props.detail2.certificateFilePath, event)}
                                                                >
                                                                    View File
                                                                </button>
                                                            ) : null
                                                        }
                                                    </div>

                                                </>
                                            )
                                    }
                                    {
                                        props && props.detail2.certificateFilePath ?
                                            (
                                                <div className='mt-5 file-uploaded-txt flex items-center'>
                                                    <span className='text-[#000]'>
                                                        {props.detail2.certificateFilePath}
                                                    </span>
                                                </div>
                                            )
                                            :
                                            null
                                    }
                                    {/* <ValidationText error={props.validStateProfessionalQualification.error.certificateFilePath} /> */}

                                </div>
                            </div>


                        </div>

                        {/* Footer */}
                        <div className="flex justify-end gap-3 mt-6">
                            <button
                                className="btn btn-border-caps"
                                onClick={() => props.setOpenProModal(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-caps"
                                onClick={() => {
                                    props.handleAddRemoveDataList(
                                        "HandleAdd",
                                        "ProfessionalQualification"
                                    );
                                    // props.setOpenProModal(false);
                                }}
                            >
                                Save
                            </button>
                        </div>

                    </div>
                </div>
            )}


            {props.openProfappModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                    <div className="bg-white w-[90%] max-w-4xl rounded-lg shadow-lg p-6 relative">

                        {/* Header */}
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-lg font-semibold">
                                Add Professional Qualification
                            </h3>
                            <button
                                className="text-xl font-bold"
                                onClick={() => props.setOpenProfappModal(false)}
                            >
                                ×
                            </button>
                        </div>

                        {/* FORM CONTENT */}
                        <div className="grid grid-cols-12 gap-4">

                            {/* Professional Qualification */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-2">
                                    Professional Qualification <span className="text-[#C00000]">*</span>
                                </h2>
                                <TextInput
                                    name="professionalQualificationName"
                                    value={props.detail3.professionalQualificationName}
                                    identity="CAPS_Application"
                                    handleChange={(e) => props.handleChange(e, "Professional_Qualification_IfApplicable")}
                                //onBlur={() => props.validateField("professionalQualificationName", "Professional_QualificationIfApplicable")}
                                />
                                {/* <ValidationText error={props.validStateProfessionalQualificationIfApplicable.error.professionalQualificationName} /> */}
                            </div>

                            {/* Organisation */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-2">
                                    Organisation <span className="text-[#C00000]">*</span>
                                </h2>
                                <TextInput
                                    name="organisation"
                                    value={props.detail3.organisation}
                                    identity="CAPS_Application"
                                    handleChange={(e) =>
                                        props.handleChange(e, "Professional_Qualification_IfApplicable")
                                    }
                                //onBlur={() =>
                                //  props.validateField("organisation", "Professional_QualificationIfApplicable")
                                // }
                                />
                                {/* <ValidationText
                                    error={
                                        props.validStateProfessionalQualificationIfApplicable.error.organisation
                                    }
                                /> */}
                            </div>

                            {/* Validity Duration */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-2">
                                    Validity Duration <span className="text-[#C00000]">*</span>
                                </h2>
                                <TextInput
                                    name="validityDuration"
                                    value={props.detail3.validityDuration}
                                    identity="CAPS_Application"
                                    handleChange={(e) =>
                                        props.handleChange(e, "Professional_Qualification_IfApplicable")
                                    }
                                //onBlur={() => props.validateField("organisation", "Professional_QualificationIfApplicable")}
                                />
                                {/* <ValidationText
                                    error={
                                        props.validStateProfessionalQualificationIfApplicable.error.validityDuration
                                    }
                                /> */}
                            </div>

                            {/* Grade of Membership */}
                            <div className="lg:col-span-6 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-2">
                                    Grade of Membership (If Applicable) <span className="text-[#C00000]"> *</span>
                                </h2>
                                <TextInput
                                    name="gradeOfMembership"
                                    value={props.detail3.gradeOfMembership}
                                    identity="CAPS_Application"
                                    handleChange={(e) =>
                                        props.handleChange(e, "Professional_Qualification_IfApplicable")
                                    }
                                //onBlur={() =>
                                //props.validateField("gradeOfMembership", "Professional_QualificationIfApplicable")
                                //}
                                />
                                {/* <ValidationText
                                    error={
                                        props.validStateProfessionalQualificationIfApplicable.error.gradeOfMembership
                                    }
                                /> */}
                            </div>

                            {/* Upload File */}
                            <div className="lg:col-span-12 col-span-12 input-sec-texts">
                                <h2 className="input-title mb-3">
                                    Upload Certificate <span className="text-[#C00000]">*</span>
                                    <span className='input mr-5 text-[#808080]'> (PDF, DOC, DOCX, JPG, JPEG, and PNG files only)</span>
                                </h2>
                                <div className="flex item-center flex-col">
                                    {
                                        props && props.isUploadProfessionalIfApplicable ?
                                            <ButtonLoader type='btn btn-caps' />
                                            :
                                            (
                                                <>
                                                    <div className='eduinfo-uplaod-button flex'>
                                                        <form className="custom-uploader custom-file-upload-btn flex">
                                                            <div className='border border-[#f3f3f3] btn  btn-caps cursor-pointer'>
                                                                <label
                                                                    htmlFor={`ProfessionalApplicable_Qualification_Training`}
                                                                    className="text-uplod text-white cursor-pointer"
                                                                >
                                                                    Upload File
                                                                </label>
                                                                <input
                                                                    className="sr-only"
                                                                    id={`ProfessionalApplicable_Qualification_Training`}
                                                                    type="file"
                                                                    onChange={(event) => props.onFileChange(event, "ProfessionalApplicable_Qualification_Training")}
                                                                />
                                                            </div>
                                                        </form>
                                                        {
                                                            props.detail3.certificatePath ? (
                                                                <button className="ml-5 2xl:px-7 lg:px-5 py-2 btn border text-[#005b9c] font-semibold tracking-normal underline"
                                                                    style={{ borderColor: '#005b9c' }}
                                                                    onClick={(event) => props.GetCPASMemberFiles('ProfessionalApplicable_Qualification_Training', props.detail3.certificatePath, event)}
                                                                >
                                                                    View File
                                                                </button>
                                                            ) : null
                                                        }
                                                    </div>

                                                </>
                                            )
                                    }
                                    {
                                        props && props.detail3.certificatePath ?
                                            (
                                                <div className='mt-5 file-uploaded-txt flex items-center'>
                                                    <span className='text-[#000]'>
                                                        {props.detail3.certificatePath}
                                                    </span>
                                                </div>
                                            )
                                            :
                                            null
                                    }
                                    {/* <ValidationText error={props.validStateProfessionalQualificationIfApplicable.error.certificatePath} /> */}

                                </div>
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="flex justify-end gap-3 mt-8">
                            <button
                                className="btn btn-border-caps"
                                onClick={() => props.setOpenProfappModal(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-caps"
                                onClick={() => {
                                    props.handleAddRemoveDataList(
                                        "HandleAdd",
                                        "ProfessionalQualificationApplicable"
                                    );
                                    //props.setOpenProfappModal(false);
                                }}
                            >
                                Save
                            </button>
                        </div>

                    </div>
                </div>
            )}

        </>
    )
}

export default EducationalInformation;